import React from 'react';
import { Button, Container, Row, Col } from 'seduo-ui';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import { path } from '../basename';
export default () => (<div>
        <Helmet title="404 Page Not Found"/>
        <section className="jumbotron text-center mb-3">
            <Container>
                <Row>
                    <Col>
                        <h1 className="jumbotron-heading display-4">404 - Not Found</h1>
                        <p>
                            <Button outline color="danger" className="mr-1" tag={Link} to={path()}>
                                Get Started
                            </Button>
                            <Button color="danger" tag={Link} to={path('components/')}>
                                View Components
                            </Button>
                        </p>
                    </Col>
                </Row>
            </Container>
        </section>
    </div>);
